import useBooleanConfig from './useBooleanConfig';

/**
 * Gates the consistent-cancellations visual treatment on Messages and Lead Management
 * (destructive Cancel CTA, struck-through cancelled tours, critical-tone status chips).
 * Kept separate from ZRM's `canShowCancelledTours` — that flag is ZRM-only — so the two
 * apps can be flipped together for a coordinated launch.
 */
export default function useConsistentCancellationsUiEnabled(): boolean {
  return useBooleanConfig('enableConsistentCancellationsUi', false);
}
